/*
structure:
- classMappings: array
  - raceNumber: number or undefined
  - classNameRegex: string or undefined
  - winSplitsEventName: string
  - winSplitsEventDateOffset: int or undefined

example: 
{
    classMappings: [
        { raceNumber: 3, classNameRegex: "^MtbO", winSplitsEventName: "O-Ringen etapp 3, MtbO" },
        { raceNumber: 3, winSplitsEventName: "O-Ringen etapp 3" },
        { raceNumber: 3, classNameRegex: " Elit$", winSplitsEventName: "O-Ringen etapp 3", winSplitsEventDateOffset: 1 }
    ]
}

WinSplits Online endpoint:
https://obasen.orientering.se/winsplits/online/sv/default.asp?eventDate={winSplitsEventStartDate}&eventName={winSplitsEventName}&categoryName={className}
*/

import { formatDate } from "../TimeUtil";

export default class WinSplitsManager {
    isEnabledForEvent(event) {
        return event && event.properties && event.properties.winSplitsOptions;
    }

    getRedirectUrl(event, race, cl, language) {
        if (!this.isEnabledForEvent(event) ||
            !race ||
            !cl) {
            return undefined;
        }

        const classMappings = (event.properties.winSplitsOptions.classMappings || []);

        for (let i=0; i<classMappings.length; i++) {
            const classMapping = classMappings[i];
            const classNameMatches = 
                !classMapping.classNameRegex || 
                new RegExp(classMapping.classNameRegex, "i").test(cl.name);
            const raceNumberMatches = classMapping.raceNumber === race.raceNumber;

            if (classNameMatches && raceNumberMatches) {
                if(!classMapping.winSplitsEventName) {
                    return undefined;
                }
                const eventDate = formatDate(race.startTime + 24*60*60*1000 * (classMapping.winSplitsEventDateOffset ?? 0), event.timeZone);
                const winSplitsLanguage = getWinSplitsLanguage(language.code);
                return `https://obasen.orientering.se/winsplits/online/${winSplitsLanguage}/default.asp?eventDate=${encodeURIComponent(eventDate)}&eventName=${encodeURIComponent(classMapping.winSplitsEventName)}&categoryName=${encodeURIComponent(cl.name)}`;
            }
        }

        return undefined;
    }
}

const getWinSplitsLanguage = language => {
    switch (language) {
        case "sv": return "sv";
        default: return "en";
    }
};